export default process.env.NEXT_PUBLIC_VERGE_FOLLOWS === "true";
